import { ReactNode } from "react";
import { SubNav, SubNavTab } from "@/components/layout/SubNav";

interface SharePointLayoutProps {
  children: ReactNode;
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

const sharePointTabs: SubNavTab[] = [
  { label: "Dashboard", path: "/sharepoint/dashboard" },
  { label: "Jobs", path: "/sharepoint/jobs" },
  { label: "Images", path: "/sharepoint/images" },
];

export const SharePointLayout = ({ children, onRefresh, isRefreshing }: SharePointLayoutProps) => {
  return (
    <div className="flex flex-col h-full">
      <SubNav tabs={sharePointTabs} onRefresh={onRefresh} isRefreshing={isRefreshing} />
      <main className="flex-1 overflow-y-auto bg-[#F5F5F5]">
        {children}
      </main>
    </div>
  );
};

